import { viewModeHelper } from '../../helpers/data-parsing/analyticsMappingParser';

import { trackSmartMetric } from './trackSmartMetric';

const getViewModeSmartMetricName = (viewMode: string) => {
  const viewModeType = viewModeHelper(viewMode);

  return `month_view_flights_tab_${viewModeType}_view`;
};

const trackViewModeSmartMetric = (viewMode: string) =>
  trackSmartMetric(getViewModeSmartMetricName(viewMode));

export { trackViewModeSmartMetric };
